import script from "./MultipleBarcodeScanMixin.vue?vue&type=script&lang=ts"
export * from "./MultipleBarcodeScanMixin.vue?vue&type=script&lang=ts"

export default script